import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import toast from 'react-hot-toast';

function BillingRedirect() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();

  useEffect(() => {
    const handle = async () => {
      if (searchParams.get('success') === 'true') {
        toast.success('Subscription activated successfully!');
        // Wait briefly for the Stripe webhook to process, then refresh
        await new Promise(r => setTimeout(r, 2000));
        await refreshUser();
      }
      if (searchParams.get('canceled') === 'true') {
        toast('Checkout canceled', { icon: 'i' });
      }
      navigate('/dashboard/settings', { state: { initialTab: 'billing' }, replace: true });
    };
    handle();
  }, []);

  return (
    <div className="flex items-center justify-center py-20">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
    </div>
  );
}

export default BillingRedirect;
